// extracted by mini-css-extract-plugin
export default {"badges":"styles_badges__0RD7q"};